import {
  GET_BLOOD_TEST_ERROR,
  GET_BLOOD_TEST_SUCCESS,
} from "../actionTypes/firstStepActionTypes";

const INITIAL_STATE = {
  error: null,
  bloodTests: [],
  bloodTestLoading: true,
  lastFetchTime: null, 
};

const firstStepReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_BLOOD_TEST_LOADING':
      return {
        ...state,
        bloodTestLoading: action.payload,
      };
      
    case GET_BLOOD_TEST_SUCCESS:
      return {
        ...state,
        error: null,
        bloodTestLoading: false,
        bloodTests: action.payload,
        lastFetchTime: Date.now(), 
      };
      
    case GET_BLOOD_TEST_ERROR:
      return {
        ...state,
        bloodTestLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default firstStepReducer;